'use strict';

/**
 * Sample Service
 */
module.service('SampleService', [ 'Restangular', '$q', SampleServiceFn ]);

function SampleServiceFn(Restangular, $q) {

	/*
	 * ------------------------------------------------------------------------------
	 * SERVICE FUNCTIONS
	 * -------------------------------------------------------------------------------
	 */

	var sampleSimplePath = '/plansamplingsimple';
	var samplePath = '/plansampling';

	var ss = {};

	ss.getLineSample = function(idSample) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one("/samplestateflowaudit", idSample).get().then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};
	
	ss.getThermobuttonInfo = function(idPlan, idSampling, idSample) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).customGET('thermobuttoninfo').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.analyzeSample = function(idPlan, idSampling, idSample, idAnalysisResult, analysisModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).one('analysis', idAnalysisResult).customPOST(analysisModel, 'analyze').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};
	
	ss.cloneSample = function(idPlan, idSampling, idSample) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).customPUT(null, 'clone').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};
	
	ss.updateAnalyzeSample = function(idPlan, idSampling, idSample, idAnalysisResult, updateModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).one('analysis', idAnalysisResult).customPUT(updateModel, 'analyze').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.nonconformSample = function(idPlan, idSampling, idSample, nonconformModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).customPOST(nonconformModel, 'notconform').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	
	ss.nontakenSample = function(idPlan, idSampling, idSample, nontakenModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).customPOST(nontakenModel, 'nottaken').then(
				function(response) {
					answer.handleSuccessfullResponse(response, response.data);
					deferred.resolve(answer);
				}, function(response) {
					answer.handleErrorResponse(response, response.data);
					deferred.reject(answer);
				});
		return deferred.promise;
	};
	
	ss.admitSample = function(idPlan, idSampling, idSample, admitModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).customPOST(admitModel, 'admit').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};
	
	ss.updateAdmitSample = function(idPlan, idSampling, idSample, updateAdmitModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).customPUT(updateAdmitModel, 'updateadmit').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.takeSample = function(idPlan, idSampling, idSample, takeModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).customPOST(takeModel, 'take').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};
	
	ss.signSamples = function(signModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.all(samplePath).customPOST(signModel, 'sample/sign').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	/**
	 * update sample
	 */
	ss.updateTakeSample = function(idPlan, idSampling, idSample, updateTakeModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).customPUT(updateTakeModel, 'take').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.asignSample = function(idPlan, idSampling, idSample, asignModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).customPOST(asignModel, 'asign').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.checkSampleElement = function(idPlan, idSampling, idSample) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).all('checksampleelement').post().then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.scheduleSample = function(idPlan, idSampling, idSample, scheduleModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).customPOST(scheduleModel, 'schedule').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.tagSample = function(idPlan, idSampling, idSample, tagModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).customPOST(tagModel, 'tag').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.addSample = function(idPlan, idSampling, addModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).customPOST(addModel, 'sample').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.updateSample = function(idPlan, idSampling, idSample, updateModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).customPUT(updateModel).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.cancelSample = function(idPlan, idSampling, idSample) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).all('cancel').post().then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.getSampleBasicInfo = function(idPlan, idSampling, idSample) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(sampleSimplePath, idPlan).one('sampling', idSampling).one('sample', idSample).get().then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.getSample = function(idPlan, idSampling, idSample) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).get().then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.getSampleDetailInfo = function(idPlan, idSampling, idSample) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).customGET('detailinfo').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.getAllSampleSimple = function(filters) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.all(sampleSimplePath).customGET('allsamples', filters).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.searchSampleBasicInfo = function(idPlan, idSampling, filters) {
		return searchBaseSample(sampleSimplePath, idPlan, idSampling, filters);
	};

	ss.searchByProfessionalSamplingBasicInfo = function(filters) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.all(sampleSimplePath).all('professionalsampling').customGET('samples', filters).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.searchSamplereceiveBasicInfo = function(filters) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.all(sampleSimplePath).customGET('samplesreceive', filters).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};
	
	ss.searchSampleSimpleHome = function(idPlan, idSampling, filters) {
		var deferred = $q.defer();
		var answer = new restResponse();
		
		Restangular.one(sampleSimplePath, idPlan).one('sampling', idSampling).customGET('simplehome', filters).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.searchSampleAnalyzeBasicInfo = function(filters) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.all(sampleSimplePath).customGET('samplesanalyze', filters).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};
	
	ss.searchSampleInterpretBasicInfo = function(filters) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.all(sampleSimplePath).customGET('samplesinterpret', filters).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};
	
	ss.getSamplesToBeInterpreted = function() {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.all(sampleSimplePath).customGET('samplestobeinterpreted', null).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.searchSampleBasicInfoWithSampleElements = function(filters) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.all(sampleSimplePath).customGET('sampleswithsampleelements', filters).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.searchAllSampleBasicInfo = function(idPlan, idSampling, filters) {
		return searchBaseAllSample(sampleSimplePath, idPlan, idSampling, filters);
	};

	ss.searchSamplesWithoutPlan = function(filters) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.all(samplePath).customGET('samples', filters).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};
	
	ss.searchSamples = function(idPlan, idSampling, filters) {
		return searchBaseSample(samplePath, idPlan, idSampling, filters);
	};

	ss.searchAllSamples = function(idPlan, idSampling, filters) {
		return searchBaseAllSample(samplePath, idPlan, idSampling, filters);
	};

	ss.addSampleAnalysis = function(idPlan, idSampling, idSample, createModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).customPOST(createModel, 'analysis').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	ss.updateSampleAnalysis = function(idPlan, idSampling, idSample, idSampleAnalysis, updateModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).one('analysis', idSampleAnalysis).customPUT(updateModel).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	ss.removeSampleAnalysis = function(idPlan, idSampling, idSample, idSampleAnalysis, updateModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).one('analysis', idSampleAnalysis).remove().then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	ss.getSampleAnalysisResult = function(idPlan, idSampling, idSample) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(samplePath, idPlan).one('sampling', idSampling).one('sample', idSample).customGET('results').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	function searchBaseSample(qual, idPlan, idSampling, filters) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(qual, idPlan).one('sampling', idSampling).customGET('samples', filters).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}
	;

	function searchBaseAllSample(qual, idPlan, idSampling, filters) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(qual, idPlan).one('sampling', idSampling).customGET('allsamples', filters).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}
	;

	return ss;
}
